import createModel, { prop } from 'models/lib/create_model';
import { ChatMessageType } from 'models/chat_message_constants';
import { ChatTemplatedCard } from 'models/chat_templated_card';
import { DataDisplayContent } from 'models/message_automation_content';

const compositeMessagePartTypes = [
  ChatMessageType.TEXT,
  ChatMessageType.HTML,
  ChatMessageType.DATA_DISPLAY,
  ChatMessageType.FLEXIBLE_CARD,
];

const CompositeChatMessagePart = createModel({
  modelName: 'CompositeChatMessagePart',

  properties: {
    messageData: prop().oneOf(DataDisplayContent, ChatTemplatedCard),
    messageType: prop()
      .oneOf(...compositeMessagePartTypes)
      .default(ChatMessageType.TEXT),
    text: prop(String),
    isRedacted: prop(Boolean).default(false),
  },

  overrideToJs(toJs) {
    return () => {
      const message = toJs();
      return { ...message, type: 'CHAT_MESSAGE' };
    };
  },

  statics: {
    overrideFromJs(fromJs) {
      return attrs => {
        switch (attrs.messageType) {
          case ChatMessageType.DATA_DISPLAY: {
            const messageData = DataDisplayContent.fromJs(attrs.messageData);
            return fromJs({ ...attrs, messageType: ChatMessageType.DATA_DISPLAY, messageData });
          }

          case ChatMessageType.FLEXIBLE_CARD: {
            const messageData = ChatTemplatedCard.fromJs(attrs.messageData);
            return fromJs({ ...attrs, messageType: ChatMessageType.FLEXIBLE_CARD, messageData });
          }

          default:
            return fromJs(attrs);
        }
      };
    },
  },
});

export const CompositeChatMessage = createModel({
  modelName: 'CompositeChatMessage',

  properties: {
    messages: prop([CompositeChatMessagePart]).isRequired,
  },
});
